import { useEffect, useState } from 'react';

import clsx from 'clsx';

export function LoadBar({
  show,
  progress,
  className,
}: {
  show: boolean;
  progress: number;
  className?: string;
}) {
  const [showBar, setShowBar] = useState(show);

  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (!show) {
      timeout = setTimeout(() => setShowBar(false), 1300);
    } else {
      setShowBar(true);
    }
    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [show]);

  if (!showBar) return null;

  return (
    <div className={clsx('flex h-16 w-full items-center', className)}>
      <div className="relative h-6 w-full rounded-full bg-gray-200 dark:bg-gray-600">
        <span
          className="pointer-events-none absolute flex h-full w-full items-center justify-center
            p-0.5 text-center text-xs font-medium leading-none dark:text-gray-100
            dark:mix-blend-difference"
        >{`${Math.round(progress)}%`}</span>
        <div
          className="bg-brand h-6 min-w-0 rounded-full transition-all duration-1000"
          style={{ width: `${Math.round(progress)}%` }}
        />
      </div>
    </div>
  );
}
